import { useState, useEffect } from 'react';
import { OrdersService } from '../services/firebase.service';

export const useOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const data = await OrdersService.getAll();
      setOrders(data);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching orders:', err);
    } finally {
      setLoading(false);
    }
  };

  const updateOrderStatus = async (orderId, status) => {
    try {
      await OrdersService.updateStatus(orderId, status);
      await fetchOrders(); // Refresh orders
      return { success: true };
    } catch (err) {
      console.error('Error updating order status:', err);
      return { success: false, error: err.message };
    }
  };

  const updateOrderWithTracking = async (orderId, status, trackingId) => {
    try {
      await OrdersService.update(orderId, { orderStatus: status, trackingId });
      await fetchOrders(); // Refresh orders
      return { success: true };
    } catch (err) {
      console.error('Error updating order with tracking:', err);
      return { success: false, error: err.message };
    }
  };

  const deleteOrder = async (orderId) => {
    try {
      await OrdersService.delete(orderId);
      await fetchOrders(); // Refresh orders
      return { success: true };
    } catch (err) {
      console.error('Error deleting order:', err);
      return { success: false, error: err.message };
    }
  };

  return { orders, loading, error, refetch: fetchOrders, updateOrderStatus, updateOrderWithTracking, deleteOrder };
};

export const useOrder = (orderId) => {
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (orderId) {
      fetchOrder();
    }
  }, [orderId]);

  const fetchOrder = async () => {
    try {
      setLoading(true);
      const data = await OrdersService.getById(orderId);
      setOrder(data);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching order:', err);
    } finally {
      setLoading(false);
    }
  };

  return { order, loading, error, refetch: fetchOrder };
};